
import Archive from "../../../assets/duotone/Archive.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArchiveIcon({ className, dataTestid = "ArchiveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Archive data-testid={dataTestid} className={classes} {...rest} />
  );
}
